import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { Form, Button, Modal } from 'react-bootstrap';
import { fabric } from 'fabric'
import FontPicker from 'react-fontpicker-ts';
import fontInfo from './signature';
import { IconDeleteOutline, IconBxText, IconCheckLg } from './icons';

let enable_submit

let fcanvas

function Item({style, family, fontStyle, weight, fontSizePx})
{
    return (
	<div style={style}>
	    <div className="mb-3"
		 style={{fontFamily: family,
			 fontStyle: fontStyle,
			 fontWeight: weight,
			 fontSize: `${fontSizePx}px`}}>
		<div>Sample for family={family}, style={fontStyle}, weight={weight}, size={fontSizePx}px</div>
		<div>abcdefghijklmnopqrstuvwxyz ABCDEFGHIJKLMNOPQRSTUVWXYZ 0123456789</div>
	    </div>
	</div>
    )
}

function ITextModal({family, setFamily, beforeShow})
{
    const [showModal, setShowModal] = useState(false),
	  [names, setNames] = useState([]),
	  [families, setFamilies] = useState(''),
	  [categories, setCategories] = useState([]),
	  [itemsPerPage, setItemsPerPage] = useState(5),
	  [numPages, setNumPages] = useState(0),
	  [pgOffset, setPgOffset] = useState(0),
	  [pgNum, setPgNum] = useState(0),
	  [category, setCategory] = useState(''),
	  [fontStyle, setFontStyle] = useState('normal'),
	  [weight, setWeight] = useState('normal'),
	  [fontSizePx, setFontSizePx] = useState(18),
	  [chosenFamily, setChosenFamily] = useState(family),
	  updateCurPage = pageno => {
	      if ( pageno < 1 ) pageno = 1
	      setPgNum(pageno)
	      setPgOffset((pageno - 1)*itemsPerPage)
	  }
    useEffect(() => {
	let n = [], c = {}
	fontInfo.forEach(fi => {
	    n.push(fi.name)
	    if ( !(fi.category in c) ) c[fi.category] = 0
	    c[fi.category]++
	})
	setCategories(Object.keys(c).toSorted())
	setCategory('handwriting')
    }, [])
    useEffect(() => {
	setNumPages(Math.floor(names.length/itemsPerPage) + (names.length % itemsPerPage > 0 ? 1 : 0))
    	setFamilies(names.slice(pgOffset, pgOffset + itemsPerPage).join(','))
    }, [names, pgOffset, itemsPerPage])
    useEffect(() => {
	if ( category ) {
	    setNames(fontInfo.filter(fi => fi.category === category).map(fi => fi.name))
	    setPgOffset(0)
	    setPgNum(1)
	}
    }, [category])
    return (
	<>
	    <span className="border rounded me-3"
		  title="Choose text font"
		  onClick={ev => {
		      beforeShow()
		      setShowModal(true)
		  }}><IconBxText/></span>
	    <Modal show={showModal} size="lg" onHide={ev => setShowModal(false)}>
		<Modal.Header closeButton>
		    <Modal.Title>Text Properties</Modal.Title>
		</Modal.Header>
		<Modal.Body>
		    <FontPicker loadFonts={families} loaderOnly/>
		    {names.length > 0 && (
			<nav aria-label="Page navigation example">
			    <ul className="pagination">
				<li className="page-item">
				    <a className="nolink page-link" aria-label="Previous"
				       onClick={ev => updateCurPage(pgNum - 1)}>
					<span aria-hidden="true">&laquo;</span>
				    </a>
				</li>
				<li className="page-item">
				    <a className="page-link nolink" aria-label="Next"
				       onClick={ev => updateCurPage(pgNum + 1)}>
					<span aria-hidden="true">&raquo;</span>
				    </a>
				</li>
				{pgNum > 2 && (
				    <li className="page-item">
					<a className="nolink page-link" aria-label="Next"
					   onClick={ev => updateCurPage(1)}>1</a>
				    </li>
				)}
				{pgNum - 2 > 1 && (
				    <li className="page-item">
					<a className="nolink page-link" aria-label="Next">...</a>
				    </li>
				)}
				{pgNum - 1 > 0 && (
				    <li className="page-item">
					<a className="nolink page-link" aria-label="Next"
					   onClick={ev => updateCurPage(pgNum - 1)}>{pgNum-1}</a>
				    </li>
				)}
				<li className="page-item active" aria-current="page">
				    <a className="nolink page-link">{pgNum}</a>
				</li>
				{numPages > pgNum + 1 && (
				    <li className="page-item">
					<a className="nolink page-link" aria-label="Previous"
					   onClick={ev => updateCurPage(pgNum + 1)}>{pgNum+1}</a>
				    </li>
				)}
				{pgNum < numPages - 1 && (
				    <li className="page-item">
					<a className="nolink page-link" aria-label="Next">...</a>
				    </li>
				)}
				{pgNum != numPages && (
				    <li className="page-item">
					<a className="nolink page-link" aria-label="Next"
					   onClick={ev => updateCurPage(numPages)}>{numPages}</a>
				    </li>
				)}
			    </ul>
			</nav>
		    )}
		    <div>
			<div className="mb-2">
			    {names.slice(pgOffset, pgOffset + itemsPerPage).map((name, ni) => (
				<div key={ni} className="d-flex justify-content-between align-items-start">
				    <Item family={name}
					  fontStyle={fontStyle}
					  weight={weight}
					  fontSizePx={fontSizePx}/>
				    <input type="radio"
					   name="chosen-family"
					   value={name}
					   checked={name === chosenFamily}
					   onChange={ev => setChosenFamily(ev.target.value)}/>
				</div>
			    ))}
			</div>
		    </div>
		</Modal.Body>
		<Modal.Footer>
		    <Button variant="secondary" onClick={ev => setShowModal(false)}>
			Close
		    </Button>
		    <Button variant="primary"
			    className="d-flex"
			    disabled={!chosenFamily}
			    onClick={ev => {
				setFamily(chosenFamily)
				setShowModal(false)
			    }}>
			<IconCheckLg/> Accept
		    </Button>
		</Modal.Footer>
	    </Modal>
	</>
    )
}

function SignatureInputField({frmid, stepId})
{
    const [step, setStep] = useState(null),
	  [freehand, setFreehand] = useState(true),
	  [freeWidth, setFreeWidth] = useState(2),
	  [fontFamily, setFontFamily] = useState(''),
	  [signature, setSignature] = useState(''),
	  freehandChecked = ev => {
	      if ( fcanvas ) {
		  fcanvas.isDrawingMode = ev.target.checked
		  fcanvas.freeDrawingBrush.width = freeWidth
		  setFreehand(ev.target.checked)
	      }
	  },
	  deleteObject = ev => {
	      if ( fcanvas ) {
		  setFreehand(false)
		  fcanvas.isDrawingMode = false
	      } else return
	      if ( ! fcanvas.getActiveObject() ) {
		  let sel = new fabric.ActiveSelection(fcanvas.getObjects(), {
		      canvas: fcanvas
		  })
		  fcanvas.setActiveObject(sel)
		  fcanvas.requestRenderAll()
	      }
	      if ( fcanvas.getActiveObject().type.toLowerCase() == 'activeselection' )
		  fcanvas.getActiveObject().getObjects().forEach(obj => fcanvas.remove(obj))
	      else
		  fcanvas.remove(fcanvas.getActiveObject());
	      fcanvas.discardActiveObject().requestRenderAll()
	  },
	  groupObjects = ev => {
	      if ( fcanvas.getActiveObject() && fcanvas.getActiveObject().type.toLowerCase() == 'activeselection' ) {
		  fcanvas.getActiveObject().toGroup()
		  fcanvas.requestRenderAll()
	      }
	  },
	  ungroupObject = ev => {
	      if ( fcanvas.getActiveObject() && fcanvas.getActiveObject().type == 'group' ) {
		  fcanvas.getActiveObject().toActiveSelection()
		  fcanvas.requestRenderAll()
	      }
	  },
	  addIText = family => {
	      const props = {
		  left: 100,
		  top: 80,
		  fontSize: 20,
		  strokeWidth: 0.2,
		  strokeUniform: true
	      }
	      if ( family ) props.fontFamily = family
	      fcanvas.add(new fabric.IText('Click and type', props));
	  },
	  generateSignature = ev => {
	      if ( fcanvas ) {
		  setFreehand(false)
		  fcanvas.isDrawingMode = false
	      }
	      if ( ! fcanvas.getActiveObject() ) {
		  let sel = new fabric.ActiveSelection(fcanvas.getObjects(), {
		      canvas: fcanvas
		  })
		  fcanvas.setActiveObject(sel)
		  fcanvas.requestRenderAll()
	      }
	      if ( fcanvas.getActiveObject() ) {
		  const sel = fcanvas.getActiveObject(),
			width = sel.width * sel.scaleX,
			height = sel.height * sel.scaleY
		  const signaturePng = fcanvas.getActiveObject().toDataURL({format: 'image/png'})
		  const canv = document.getElementById('freehand-sample-canv'),
			ctx = canv.getContext('2d'),
			img = new Image
		  canv.width = width + 2*step.xPadding
		  canv.height = height + 2*step.yPadding
		  ctx.fillStyle = 'white'
		  ctx.fillRect(0, 0, canv.width, canv.height)
		  img.onload = () => ctx.drawImage(img, step.xPadding, step.yPadding)
		  img.src = signaturePng
		  setSignature(signaturePng)
	      }
	  },
	  saveSignature = ev => {
	      const a = document.createElement('a')
              a.href = document.getElementById('freehand-sample-canv').toDataURL('image/png')
              a.download = 'signature.png'
              a.click()
	  },
	  clearSignature = ev => {
	      const canv = document.getElementById('freehand-sample-canv'),
		    ctx = canv.getContext('2d'),
		    img = new Image
	      ctx.fillStyle = 'white'
	      ctx.fillRect(0, 0, canv.width, canv.height)
	      setSignature('')
	  },
	  uploadSignature = ev => {
	      const el = document.createElement('input')
	      el.type = 'file'
	      el.accept = 'image/*'
	      el.addEventListener('change', changeev => {
		  const reader = new FileReader()
		  reader.onload = () => {
		      const canv = document.getElementById('freehand-sample-canv'),
			    ctx = canv.getContext('2d'),
			    img = new Image
		      ctx.fillStyle = 'white'
		      img.onload = () => {
			  canv.width = img.width
			  canv.height = img.height
			  ctx.drawImage(img, 0, 0)
		      }
		      img.src = reader.result
		      setSignature(reader.result)
		  }
		  reader.readAsDataURL(changeev.target.files[0])
	      })
	      el.click()
	  }
    useEffect(() => {
	enable_submit(false)
	if ( frmid && stepId ) {
	    fetch(`/pub/form/${frmid}/${stepId}/`)
		.then(r => r.ok ? r.json() : Promise.reject(r))
		.then(json => {
		    setStep(json)
		    enable_submit(!json.valueRequired)
		})
		.catch(r => {
		    console.error('error in operation: %O, %O', r.status, r.statusText)
		    r.text().then(text => console.error('detail: %O', text))
		})
	}
    }, [frmid, stepId])
    useEffect(() => {
	const canvasEl = document.getElementById('freehand-canv')
	if ( canvasEl ) {
	    const parent = canvasEl.closest('div'),
		  rect = parent.getBoundingClientRect();
	    if ( ! fcanvas ) {
		fcanvas = new fabric.Canvas('freehand-canv', {width: rect.width, height: rect.height})
		if ( freehand ) {
		    fcanvas.isDrawingMode = freehand
		    fcanvas.freeDrawingBrush.width = freeWidth
		}
	    }
	}
    }, [])
    useEffect(() => {
	enable_submit(signature && signature.length > 0)
    }, [signature])
    return (
	<>
	    {step && (
		<>
		    <input type="hidden" name={step.dataFields[0].id} value={signature}/>
		    <div className="form-text field-descr"
			 dangerouslySetInnerHTML={{__html:step.fieldDescr}}></div>
		</>
	    )}
	    <div className="col-12">
		<div className="d-flex align-items-center gap-1 mb-3">
		    <div class="d-flex me-3">
			<Form.Switch id="freehandCheckbox"
				     checked={freehand}
				     className="d-flex align-items-center"
				     onChange={freehandChecked}/>
			<label for="freehandCheckbox" className="w-100 tertiary-text">
			    Free hand
			</label>
		    </div>
		    <ITextModal beforeShow={() => {
				    setFreehand(false)
				    if ( fcanvas ) fcanvas.isDrawingMode = false
				}}
				family={fontFamily}
				setFamily={family => {
				    setFontFamily(family)
				    addIText(family)
				}}/>
		    <span className="border rounded"
			  title="Delete selected object(s)"
			  onClick={deleteObject}><IconDeleteOutline/></span>
		</div>
	    </div>
	    <div className="row">
		<div className="col-12">
		    <div className="canvas-div mb-3 bg-white">
			<canvas style={{height: '300px'}}
				id="freehand-canv"
				className="w-100 shadow"></canvas>
		    </div>
		</div>
	    </div>
	    <div className="row g-0">
		<div className="col-12 mb-3">
		    <div className="d-flex gap-2">
			<button type="button"
				className="btn btn-secondary tertiary-text"
				onClick={clearSignature}>Clear</button>
			<button type="button"
				className="btn btn-info tertiary-text"
				onClick={generateSignature}>Update</button>
			<button type="button"
				className="btn btn-primary tertiary-text"
				onClick={saveSignature}>Save</button>
			<button type="button"
				className="btn btn-warning tertiary-text"
				onClick={uploadSignature}>Upload</button>
		    </div>
		</div>
		<div className="col-12">
		    <canvas height="80"
			    width="250"
			    id="freehand-sample-canv"
			    className="bg-white rounded border shadow"/>
		</div>
	    </div>
	</>
    )
}

(function() {
    const rootId = document.currentScript.getAttribute('data-rootid'),
	  el = document.getElementById(rootId),
	  stepId = el.getAttribute('data-stepid'),
	  frmid = el.getAttribute('data-frmid')
    enable_submit = (enable) => {
	if ( 'enable_submit' in window ) window.enable_submit(stepId, enable)
    }
    createRoot(el).render(<SignatureInputField frmid={el.getAttribute('data-frmid')}
					       stepId={stepId}/>);
})();
